module.exports = __webpack_public_path__ + "static/img/image_tag_present.915a989.png";